/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
mutation VendorInvoiceDeleteMutation($vendorInvoiceId: ID!) {
  VendorInvoiceDelete(vendorInvoiceId: $vendorInvoiceId) {
    id
    message
    status
  }
}
`
